import jsPDF from 'jspdf'; // eslint-disable-line import/no-named-as-default

import { STOCK_MANAGER_PDF_TABLE_ID } from 'stocks/consts';

import 'jspdf-autotable';

export const stockManagerPdfGenerator = (options) => {
  const { date, totalCost, totalRetail, salonId, t } = options;

  // eslint-disable-next-line new-cap
  const doc = new jsPDF('p', 'pt');
  const res = doc.autoTableHtmlToJson(document.getElementById(STOCK_MANAGER_PDF_TABLE_ID));
  const { height } = doc.internal.pageSize;

  // doc.addImage(imgData, 'PNG', 426, 35, 115, 68); // x, y, width and height

  doc.setFontSize(14);
  doc.setTextColor('#192340'); // dark blue
  doc.text(t('stocks.stockManagerPdf.stockList', { date }), 45, 50); // x, y
  doc.text(t('stocks.stockManagerPdf.totalCostValue', { totalCost }), 45, 70);
  doc.text(t('stocks.stockManagerPdf.totalRetailValue', { totalRetail }), 45, 88);

  doc.autoTable(res.columns, res.data, {
    startY: 100, //  startY: height, => start on new page
    theme: 'grid', // 'striped', 'grid' or 'plain
    font: 'helvetica', // helvetica, times, courier
    lineWidth: 0.5, // tbl border width
    fontStyle: 'normal', // normal, bold, italic, bolditalic
    // tableLineColor: 'red',
    // tableLineWidth: 1,
    halign: 'left', // left, center, right
    valign: 'middle', // top, middle, bottom
    fillStyle: 'F', // 'S', 'F' or 'DF' (stroke, fill or fill then stroke)
    columnWidth: 'auto', // 'auto', 'wrap' or a number
    headerStyles: {
      cellPadding: 6,
      fontSize: 8.3, // px
      fillColor: '#FFFFFF', // brg pink
      textColor: '#192340', // dark blue
      lineColor: '#C8C7CC', // border
      lineWidth: 0.5, // tbl border width
      valign: 'middle',
    },
    styles: {
      fontSize: 8.8, // px
      cellPadding: 6,
      textColor: '#192340', // dark blue
      fillColor: 255, // tbl background
      lineColor: '#DFDFE0', // tbl border color
      valign: 'middle',
    },

    afterPageContent(data) {
      doc.setFontSize(10);
      doc.text(' ', 45, height - data.settings.margin.bottom - 10);
    },
  });

  doc.save(t('stocks.stockManagerPdf.fileName', { salonId, date }));
};
